// src/components/common/LockedFeatureTooltip.jsx
import React, { useState } from 'react';
import { Tooltip } from 'reactstrap';
import PricingModal from './upgrade-pricing-modal';

const LockedFeatureTooltip = ({
  id,
  message = 'This feature is locked. Upgrade your plan to enable it.',
  label = 'Locked',
  iconClass = 'bx bx-lock-alt text-dark me-1',
  iconSize = 18,
  hideLock,
  value,
  hideButtonStyles
}) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggleTooltip = () => setTooltipOpen(!tooltipOpen);
  const [showPricingModal, setShowPricingModal] = useState(false);

  return (
    <div id={id} className="d-flex align-items-center">
      <div
        id={id}
        className={`d-flex align-items-center text-muted ${!hideButtonStyles && 'btn'}`}
        style={{ cursor: 'pointer' }}
        onClick={() => setShowPricingModal(true)}
      >
        {/* {!hideLock&&(
      <i className={iconClass} style={{ fontSize: iconSize }}></i>
        )} */}
        <span style={{ fontSize: 13, color: '#000' }}>
          {/* {label} */}
          {value || 'Upgrade Plan'} &nbsp;
          <span className="badge bg-dark">Pro</span>
        </span>
      </div>
      <Tooltip placement="top" isOpen={tooltipOpen} target={id} toggle={toggleTooltip}>
        {message}
      </Tooltip>
      <PricingModal isOpen={showPricingModal} onClose={() => setShowPricingModal(false)} />
    </div>
  );
};

export default LockedFeatureTooltip;
